import Image1 from "../assets/Image1.jpeg";
import Image2 from "../assets/Image2.jpeg";
import Image3 from "../assets/Image3.jpeg";
import Image4 from "../assets/Image4.jpeg";
import Image5 from "../assets/Image5.jpeg";
import Image6 from "../assets/Image6.jpeg";
import Image7 from "../assets/Image7.jpeg";
import Image8 from "../assets/Image8.jpeg";
import Image9 from "../assets/Image9.jpeg";
import Image10 from "../assets/Image10.jpeg";
import Image11 from "../assets/Image11.jpeg";
import Image12 from "../assets/Image12.jpeg";
import Image13 from "../assets/Image13.jpeg";
import Image14 from "../assets/Image14.jpeg";
import Image15 from "../assets/Image15.jpeg";
import Image16 from "../assets/Image16.jpeg";

function Gallery() {

  const images = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8,
    Image9,
    Image10,
    Image11,
    Image12,
    Image13,
    Image14,
    Image15,
    Image16
  ];

  return (
    <section id="gallery" className="section">
      <h2>Our Happy Moments</h2>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div className="gallery-card" key={index}>
            <img
              src={img}
              alt={`Tiny Toes Activity ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;